import { useTranslation } from '@amusnet/translations/react'
import checkBoxChecked from '@assets/intro-screen/checkbox-input-checked.svg'
import checkBoxUnchecked from '@assets/intro-screen/checkbox-input-unchecked.svg'
import { useConfigurationStore } from '@stores/index'
import React, { useState } from 'react'

type CheckBoxSectionProps = {
    className: string
    textColor: string
    textStrokeColor: string
    textShadowColor: string
}

export const CheckBoxSection: React.FC<CheckBoxSectionProps> = (props) => {
    const gin = useConfigurationStore((s) => s.gin)

    const [inputState, setInputState] = useState(false)
    const { t } = useTranslation()

    const { className, textColor, textStrokeColor, textShadowColor } = props

    const handleOnInputClick = () => {
        setInputState((prev) => {
            localStorage[prev ? 'removeItem' : 'setItem'](`toSkipIntro-${gin}`, prev ? '' : '1')

            return !prev
        })
    }

    return (
        <div className={className}>
            <div
                className={
                    '[paint-order:stroke_fill] h-[36px] font-bold not-italic text-3xl leading-[36px] text-center'
                }
                style={{
                    color: textColor,
                    filter: `drop-shadow(0 3px 0 ${textShadowColor})`,
                    WebkitTextStroke: `4px ${textStrokeColor}`,
                }}
            >
                {t('gameui.intro.dontShowAgain')}
            </div>
            <button onClick={handleOnInputClick}>
                <img src={inputState ? checkBoxChecked : checkBoxUnchecked} width={44} height={44} />
            </button>
        </div>
    )
}
